var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 43.08H0.54C0.24 43.08 0 42.84 0 42.54V3.54C0 3.24 0.24 3 0.54 3H9V2.04C9 1.74 9.24 1.5 9.54 1.5H12V0.54C12 0.24 12.24 0 12.54 0H18.54C18.84 0 19.08 0.24 19.08 0.54V1.5H21.54C21.84 1.5 22.08 1.74 22.08 2.04V3H30.54C30.84 3 31.08 3.24 31.08 3.54V42.54C31.08 42.84 30.84 43.08 30.54 43.08H1.5ZM1.08 42H30V4.08H22.08V5.04C22.08 5.34 21.84 5.58 21.54 5.58H9.54C9.24 5.58 9 5.34 9 5.04V4.08H1.08V42ZM10.08 4.5H21V2.58H18.54C18.24 2.58 18 2.34 18 2.04V1.08H13.08V2.04C13.08 2.34 12.84 2.58 12.54 2.58H10.08V4.5ZM26.79 31.08H4.29V30H26.79V31.08ZM26.79 25.08H4.29V24H26.79V25.08ZM26.79 19.08H4.29V18H26.79V19.08ZM26.79 13.08H4.29V12H26.79V13.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.38239d2e11f0020d32d04d7302e0c19f.svg";
export { ForwardRef as ReactComponent };